import { getParamsObj } from './search';
import { createUrl } from './utils';

export function parse(urlToParse) {
  const url = createUrl(urlToParse);
  const { pathname } = url;
  const {
    catalogues: catalogs = [],
    selectedNode: selectedNodeId,
    ...searchParams
  } = getParamsObj(url);
  const [, retailUnit, languageCode] = pathname.split('/');
  const sourceTree = catalogs[0];
  const targetTree = catalogs[1];

  return {
    ...searchParams,
    languageCode,
    retailUnit,
    selectedNodeId,
    sourceTree,
    targetTree,
  };
}
